'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _UITag = require('../../tag/UITag');

var _UITag2 = _interopRequireDefault(_UITag);

var _SyntheticEvent = require('../../core/SyntheticEvent');

var _SyntheticEvent2 = _interopRequireDefault(_SyntheticEvent);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _react2.default.createClass({
  displayName: 'MultiSelectValue',

  propTypes: {
    children: _react.PropTypes.node,
    closeable: _react.PropTypes.bool,
    disabled: _react.PropTypes.bool,
    onClick: _react.PropTypes.func,
    onRemove: _react.PropTypes.func,
    value: _react.PropTypes.object
  },

  handleMouseDown: function handleMouseDown(evt) {
    var _props = this.props,
        onClick = _props.onClick,
        value = _props.value;

    if (evt.type === 'mousedown' && evt.button !== 0) {
      return;
    }
    if (onClick) {
      evt.stopPropagation();
      onClick((0, _SyntheticEvent2.default)(value));
    }
  },
  handleCloseMouseDown: function handleCloseMouseDown(evt) {
    var _props2 = this.props,
        onRemove = _props2.onRemove,
        value = _props2.value;

    onRemove(value);

    // Prevent input focus, which leads to scroll jank (#1724)
    evt.preventDefault();
    evt.stopPropagation();
  },
  render: function render() {
    var _props3 = this.props,
        children = _props3.children,
        closeable = _props3.closeable,
        disabled = _props3.disabled,
        value = _props3.value;


    var computedUse = value.tagUse || 'default';

    return _react2.default.createElement(
      _UITag2.default,
      {
        _onCloseMouseDown: this.handleCloseMouseDown,
        _bordered: true,
        closeable: typeof closeable === 'boolean' ? closeable : !disabled && value.clearableValue !== false,
        onMouseDown: this.handleMouseDown,
        onTouchEnd: this.handleMouseDown,
        use: computedUse
      },
      children
    );
  }
});
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/UIComponents/static-2.2644/js/input/utils/MultiSelectValue.js
// module id = 557
// module chunks = 3 4 5